import { createSlice } from '@reduxjs/toolkit';
import qs from 'qs';
import api from '../utils/httpClient';
import { createAsyncThunk } from '@reduxjs/toolkit';

interface GetDeviceForBillingReportOptions {
  accountId?: string;
  startDate?: string;
  endDate?: string;
}

export const getDeviceForBillingReportPromise = async (
  options: GetDeviceForBillingReportOptions
) => {
  const query = qs.stringify(options);
  return api.get(`/report/device_for_billing?${query}`);
};

export const getAccountCallsThunk = createAsyncThunk(
  'reports/getAccountCallsThunk',
  async (params: { accountId: string; startDate: string, endDate: string }) => {
    let url = `report/calls?accountId=${params.accountId}&startDate=${params.startDate}&endDate=${params.endDate}`;
    console.log('getAccountCallsThunk params', url);

    const response = await api.get(url, {
      timeout: 30000,
    });
    console.log('getAccountCallsThunk response', response.data);
    return response.data;
  }
);

export const getExternalAppsUsageReportDataThunk = createAsyncThunk(
  'reports/getExternalAppsUsageReportDataThunk',
  async (params: { startDate: string, endDate: string }) => {
    const paramsQs = qs.stringify(params);
    let url = `report/apps_usage?${paramsQs}`;
    console.log('getExternalAppsUsageReportDataThunk params', url);
    const response = await api.get(url, {
      timeout: 30000,
    });
    console.log('getExternalAppsUsageReportDataThunk response', response);
    return response.data;
  }
);

const initialState: {
  status: string;
  error: string;
  calls: any;
  apps_usage: {
    loading: boolean;
    complete: boolean;
    error: string;
    data: { "Name": string, "ResidentUsed": number, "TotalUsage": number, "TotalHours": number }[];
  },
} = {
  status: '',
  error: '',
  calls: {},
  apps_usage: {
    loading: false,
    complete: false,
    error: '',
    data: [],
  },
};

const reportsSlice = createSlice({
  name: 'reports',
  initialState: initialState,
  reducers: {
    reportsSliceClean(state, action) {
      console.log('reportsSliceClean', action);
      state.calls.loading = false;
      state.calls.complete = false;
      state.calls.error = '';
    },
    reportsAppUsageClean(state, action) {
      console.log('reportsAppUsageClean', action);
      state.apps_usage.loading = false;
      state.apps_usage.complete = false;
      state.apps_usage.data = [];
      state.apps_usage.error = '';
    },
  },
  extraReducers: (builder) => {
    //get calls report
    builder.addCase(getAccountCallsThunk.pending, (state) => {
      state.calls.loading = true;
      state.calls.complete = false;
      state.calls.error = '';
    });
    builder.addCase(getAccountCallsThunk.fulfilled, (state, action) => {
      state.calls.loading = false;
      state.calls.complete = true;
      state.calls = Object.assign(state.calls, action.payload);
    });
    builder.addCase(getAccountCallsThunk.rejected, (state, action) => {
      state.calls.loading = false;
      state.calls.complete = false;
      state.calls = Object.assign(state.calls, action.payload);
      state.calls.error = action.error ? action.error.message! : '';
    });
    //get apps usage report
    builder.addCase(getExternalAppsUsageReportDataThunk.pending, (state) => {
      state.apps_usage.loading = true;
      state.apps_usage.complete = false;
      state.apps_usage.error = '';
      state.apps_usage.data = []
    });
    builder.addCase(getExternalAppsUsageReportDataThunk.fulfilled, (state, action) => {
      state.apps_usage.loading = false;
      state.apps_usage.complete = true;
      state.apps_usage.error = '';
      state.apps_usage.data = action.payload
    });
    builder.addCase(getExternalAppsUsageReportDataThunk.rejected, (state, action) => {
      state.apps_usage.loading = false;
      state.apps_usage.complete = false;
      state.apps_usage.data = []
      state.apps_usage.error = action.error ? action.error.message! : '';
    });
  },
});

export const { reportsSliceClean, reportsAppUsageClean } = reportsSlice.actions;
export default reportsSlice;